module.exports = __webpack_public_path__ + "static/media/nam_thumb.c74a6d3a.jpg";